(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["customer-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('editable-customer-reviews')) {
    customElements.define('editable-customer-reviews', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.cgr__track');
        this.controls = this.querySelector('.cgr__controls');
        this.previous = this.querySelector('[data-previous]');
        this.next = this.querySelector('[data-next]');
        if (!this.track || this.abort) return;
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        const update = () => {
          const maximum = this.track.scrollWidth - this.track.clientWidth;
          const position = Math.abs(this.track.scrollLeft);
          this.controls.hidden = maximum < 3 || this.dataset.showControls === 'false';
          this.previous.disabled = position < 3;
          this.next.disabled = position >= maximum - 3;
        };
        const move = (direction) => {
          const card = this.track.querySelector('.cgr__card');
          if (!card) return;
          const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
          const sign = getComputedStyle(this.track).direction === 'rtl' ? -1 : 1;
          this.track.scrollBy({
            left: direction * sign * (card.getBoundingClientRect().width + gap),
            behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
          });
        };
        this.previous.addEventListener('click', () => move(-1), options);
        this.next.addEventListener('click', () => move(1), options);
        this.track.addEventListener('scroll', update, { ...options, passive: true });
        this.track.addEventListener('keydown', (event) => {
          if (event.target !== this.track || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          const rtl = getComputedStyle(this.track).direction === 'rtl';
          if (event.key === 'Home' || event.key === 'End') {
            this.track.scrollTo({ left: event.key === 'Home' ? 0 : this.track.scrollWidth * (rtl ? -1 : 1), behavior: 'instant' });
          } else {
            move((event.key === 'ArrowRight' ? 1 : -1) * (rtl ? -1 : 1));
          }
        }, options);
        this.addEventListener('shopify:block:select', (event) => {
          const card = Array.from(this.track.children).find((item) => item.dataset.reviewId === event.detail.blockId);
          if (card) card.scrollIntoView({ behavior: 'instant', block: 'nearest', inline: 'nearest' });
        }, options);
        this.resize = new ResizeObserver(update);
        this.resize.observe(this.track);
        update();
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.resize?.disconnect();
        this.abort = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["google-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lsm-google-reviews')) {
    customElements.define('lsm-google-reviews', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.sgr__track');
        this.controls = this.querySelector('.sgr__controls');
        this.previous = this.querySelector('[data-previous]');
        this.next = this.querySelector('[data-next]');
        if (!this.track || this.abort) return;
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        const update = () => {
          const maximum = this.track.scrollWidth - this.track.clientWidth;
          const position = Math.abs(this.track.scrollLeft);
          this.controls.hidden = maximum < 3;
          this.previous.disabled = position < 3;
          this.next.disabled = position >= maximum - 3;
        };
        const move = (direction) => {
          const card = this.track.querySelector('.sgr__card');
          if (!card) return;
          const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
          const sign = getComputedStyle(this.track).direction === 'rtl' ? -1 : 1;
          this.track.scrollBy({
            left: direction * sign * (card.getBoundingClientRect().width + gap),
            behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
          });
        };
        this.previous.addEventListener('click', () => move(-1), options);
        this.next.addEventListener('click', () => move(1), options);
        this.track.addEventListener('scroll', update, { ...options, passive: true });
        this.track.addEventListener('keydown', (event) => {
          if (event.target !== this.track || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          const rtl = getComputedStyle(this.track).direction === 'rtl';
          if (event.key === 'Home' || event.key === 'End') {
            this.track.scrollTo({ left: event.key === 'Home' ? 0 : this.track.scrollWidth * (rtl ? -1 : 1), behavior: 'instant' });
          } else {
            move((event.key === 'ArrowRight' ? 1 : -1) * (rtl ? -1 : 1));
          }
        }, options);
        this.addEventListener('shopify:block:select', (event) => {
          const card = Array.from(this.track.children).find((item) => item.dataset.reviewId === event.detail.blockId);
          if (card) card.scrollIntoView({ behavior: 'instant', block: 'nearest', inline: 'nearest' });
        }, options);
        this.resize = new ResizeObserver(update);
        this.resize.observe(this.track);
        update();
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.resize?.disconnect();
        this.abort = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
